import {useEffect, useState} from "react"
import React from 'react'
import styled from 'styled-components'
import HouseSidingIcon from "@mui/icons-material/HouseSiding";
import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboard";
import AssessmentIcon from "@mui/icons-material/Assessment";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import ManageHistoryIcon from "@mui/icons-material/ManageHistory";
import { Circle, KeyboardArrowDown} from "@mui/icons-material";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import {grey} from '@mui/material/colors'
import {NavLink, Link} from "react-router-dom";
import { useLocation } from 'react-router-dom';


const SidebarItemMain = styled.div`
    display: flex;
    flex-direction: column;
    -webkit-box-pack: start;
    justify-content:center;
    -webkit-box-align: center;
    /* width: 100%; */
    /* box-sizing: border-box; */
    /* text-align: left; */
    border-radius: 10px;
    min-height:45px;
`
const SidebarTitle = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'active',
})`
   display:flex;
   align-items: center;
   background-color:${({ active }) => active? "#5C5891":"#fff"};
   border-radius: 10px;
   min-height:45px;
   margin: 2px;
`

const IconWrapper = styled.div`
    margin: 10px;
    
`
const SidebarContent = styled.div`
    display: ${(props) => props.disp};
    flex-direction: column;
    padding-left: ${({ padding }) => `${padding}px`};
`
const Sidebaritemplain = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'active',
})`
    display:flex;
    min-height:45px;   
    background-color:${({ active }) => active? "#5C5891":"#fff"};
    border-radius: 10px;
    margin: 2px;
`

const ItemTitle = styled.div`
    display: ${({sidebarDisplay}) => sidebarDisplay? "flex":"none"};
    justify-content: center;
    align-items: center;
    font-family: "Roboto","Helvetica","Arial",sans-serif;
    font-size: 0.8571428571428571rem;
    line-height: 1.5;
    letter-spacing: 0.00938em;
    font-weight: 700;
    margin-left:10px;
    margin-right:10px;
`



export const SidebarItem = ({keyprop,item, itemicon, sideBarOpen}) =>{
    const [open, setOpen] = useState(false)
    const [displ, setDispl] = useState('none')
    const [padd, setPadd] = useState()
    const [isActive, setIsActive] = useState(false)
    const location = useLocation();
    const pathArray = location.pathname.split("/").filter(x => x !== "");
    pathArray.pop();
  
    const handlekeydownclick = () =>{
        setOpen(!open);
        setDispl(displ === "none" ? "flex" : "none");
      }

    const navlinkstyle = ({ isActive: navIsActive }) =>{
        // Update our local state when NavLink's active state changes
        if (navIsActive !== isActive) {
            setTimeout(() => setIsActive(navIsActive), 0);
        }
        return {
            color: navIsActive ? "white" : "black",
            textDecoration: 'none'
        };
    }
 
    useEffect(() => {
        if(item?.icon?.length){
            setPadd(60);
        }else{
            setPadd(10);
        }   
    }, [keyprop])

    useEffect(() => {
       if(sideBarOpen === false){
        setDispl("none")
       }
       if(sideBarOpen === true){
            const actualPathVariable = item.path.split("/")[item.path.split("/").length - 1]
            if(pathArray.length && pathArray.includes(actualPathVariable)){
                setDispl("flex")
            }else{
                setDispl("none")
            }
       }
    }, [sideBarOpen])

    // Check initial active state on mount and location changes
    useEffect(() => {
        const checkIfActive = () => {
            const currentPath = location.pathname;
            const itemPath = item.path;
            
            // Check if current path matches this item's path or any of its children
            const shouldBeActive = currentPath === itemPath || 
                (item.childrens && item.childrens.some(child => currentPath === child.path)) ||
                (itemPath && currentPath.startsWith(itemPath + '/'));
            
            setIsActive(shouldBeActive);
        };
        
        checkIfActive();
    }, [location.pathname, item.path, item.childrens])

    const iconColor = isActive ? grey[50] : grey[600];
    const Iconlist = {
    Dashboard: <SpaceDashboardIcon sx={{ color: iconColor }}/>,
    Management: <ManageHistoryIcon sx={{ color: iconColor }}/>,
    Reports: <AssessmentIcon sx={{ color: iconColor }} />,
    Dot:<Circle style={{ fontSize: 10 }}/>,
    Home:<HouseSidingIcon sx={{ color: iconColor }} />,
    People:<Diversity3Icon sx={{ color: iconColor }}/>,
    MyProfile:<AccountCircleIcon sx={{ color: iconColor }}/>,
}

   
    if(item.childrens){    
   
        return(
            <SidebarItemMain>
                <SidebarTitle active={isActive}>
                    {/* <IconTitleSpan> */}
                        { item.icon && <IconWrapper><Link to = {item.path}>{Iconlist[item.icon]}</Link></IconWrapper>}
                       
                        <ItemTitle sidebarDisplay={sideBarOpen} ><NavLink to = {item.path} style={navlinkstyle} >{item.title}</NavLink></ItemTitle>
                        
                    {/* </IconTitleSpan> */}
                    {sideBarOpen && <KeyboardArrowDown onClick={handlekeydownclick}/>}              
                </SidebarTitle >
                <SidebarContent disp = {displ} padding = {padd} >
                { item.childrens.map((child, index) => <SidebarItem key={index} keyprop={index} item={child} itemicon={item.icon} sideBarOpen={sideBarOpen} />) }
                </SidebarContent>
            </SidebarItemMain>
 
            )
    }else{
        return(
            <Sidebaritemplain href={item.path || "#"} active={isActive} >
                { item.icon && <IconWrapper><Link to = {item.path}>{Iconlist[item.icon]}</Link></IconWrapper>}
            <ItemTitle sidebarDisplay={sideBarOpen}><NavLink to = {item.path} style={navlinkstyle}>{item.title}</NavLink></ItemTitle>
            </Sidebaritemplain>

        )
    }
}